var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"order-status"},[_c('HelperViewStatus',{attrs:{"status":_vm.status,"title":_vm.title,"description":_vm.description,"button-label":_vm.buttonLabel},on:{"click":_vm.emitOnButtonClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }